import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "./slices";
import { api } from "slices/api";

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter
        basename={process.env.PUBLIC_URL}
        getUserConfirmation={(message, callback) => {
          // this is the default behavior
          const allowTransition = window.confirm("Hello");
          callback(allowTransition);
        }}
      >
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
